import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupsGlobalDto } from '../interfaces';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GroupsServiceDTO } from '../interfaces/groups/groups-services.interface';
import { GroupsContactsDTO } from '../interfaces/groups/groups-contacts.interface';
import { GroupsMembersParams } from 'src/app/shared/models/iCourrier/groups/groups-members';
import { GroupsMembersDTO } from '../interfaces/groups/groups-members.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  private iCourrierURL: string;
  public apiContactiCourrierBaseUrl: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
    this.apiContactiCourrierBaseUrl = config.apiContactiCourrierV1BaseUrl;
  }

  //#region Global groups
  public fetchGlobalGroups(): Observable<GroupsGlobalDto[]> {
    return this.http.get<GroupsGlobalDto[]>(`${this.iCourrierURL}/Global/Groupes`);
  }
  //#endregion

  //#region Groupes Services
  getGroupesServices(groupsIds: number[]): Observable<GroupsServiceDTO[]> {
    return this.http.get<GroupsServiceDTO[]>(`${this.iCourrierURL}/Global/GroupesServices`, {
      params: new HttpParams().set('groupIds', `${groupsIds}`),
    });
  }
  //#endregion

  //#region Groupes Contacts
  getGroupesContacts(groupsIds: number[]): Observable<GroupsContactsDTO[]> {
    return this.http.get<GroupsContactsDTO[]>(`${this.apiContactiCourrierBaseUrl}/Global/GroupesContacts`, {
      params: new HttpParams().set('groupIds', `${groupsIds}`),
    });
  }
  //#endregion

  // #region GroupesMembres
  // Ce que l'on reçoit c'est le contactId d'un USER
  // donc si on veut l'ajouter quelque part, il faudra le mettre en contactIdiAdmin
  getGroupesMembres(data?: GroupsMembersParams): Observable<GroupsMembersDTO[]> {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    return this.http.get<GroupsMembersDTO[]>(`${this.iCourrierURL}/Global/GroupesMembres/Search?${params}`);
  }
  //#endregion
}
